import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import quotation from 'src/repositories/quotation';
import { API_KEY } from 'src/constants/apiKey';
import { productFormat } from 'src/utils/product';

const useProductMachiningMultiple = (params, setMachiningsData) => {
  const productSplit = productFormat.splitProductId(params?.product);

  const { ...rest } = useQuery<
    AxiosResponse<Response.MachiningMethod>,
    AxiosError<any>
  >(
    [
      API_KEY.MACHINING_METHOD,
      {
        typeCd: params?.hinshL3Cd,
        shapeCd: params?.keijoL3Cd,
        hakudoShhnCd: productSplit?.hakudoShhnCd,
        shhnCd: productSplit?.shhnCd,
        api1ShhnCd: productSplit?.api1ShhnCd,
        api2ShhnCd: productSplit?.api2ShhnCd,
      },
    ],
    quotation.getProductMachining,
    {
      retry: 0,
      enabled: !!params?.product,
      onSuccess(res) {
        const methodsData =
          res?.data?.item?.methods?.map((item) => ({
            label: item.name,
            value: item.code,
            description: item.description,
          })) ?? [];
        setMachiningsData({
          ...res?.data?.item,
          methods: methodsData,
        });
      },
      onError(err) {
        console.log(err.response);
      },
    },
  );

  return {
    ...rest,
  };
};

export default useProductMachiningMultiple;
